import { render, staticRenderFns } from "./GuiasStock.vue?vue&type=template&id=2a1e20ae&scoped=true"
import script from "./GuiasStock.vue?vue&type=script&lang=js"
export * from "./GuiasStock.vue?vue&type=script&lang=js"
import style0 from "./GuiasStock.vue?vue&type=style&index=0&id=2a1e20ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e20ae",
  null
  
)

export default component.exports